var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "./Base";
export default (function (props) {
    return (React.createElement(BaseSvgIcon, __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "#3D3D36", transform: "translate(12.000000, 12.500000) rotate(-270.000000) translate(-12.000000, -12.500000) translate(5.500000, 3.500000)", d: "M0.1875,-4.28101998e-13 L1.1875,-4.28101998e-13 L1.1875,18 L0.1875,18 L0.1875,-4.28101998e-13 Z M5.8125,9.00863467 L6.8125,9.00863467 L6.8125,18 L5.8125,18 L5.8125,9.00863467 Z M11.4375,3.0656171 L12.4375,3.0656171 L12.4375,18 L11.4375,18 L11.4375,3.0656171 Z" })));
});
